export class BigQueryNativePitrBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "BigQueryNativePitrBackupResourceType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BigQueryNativePitrBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
